import React from "react";
import styled from "styled-components";

//
import MainTop from "./sections/MainTop";
import Service from "../../sections/Service";
import AboutClinic from "./sections/AboutClinic";
import BookAppointment from "../../sections/BookAppointment";
import OurAdvantage from "./sections/OurAdvantage";
import MeetDoctors from "./sections/MeetDoctors";
import ContactSection from "../../sections/ContactSection";
import Location from "../../sections/Location";
import MainReview from "./sections/MainReview";

export default function Main() {
  return (
    <StyledMain>
      <MainTop />
      <AboutClinic />
      <Service />
      <MeetDoctors />
      <OurAdvantage />
      <div className="main__free-space"></div>
      <BookAppointment />
      <MainReview />
      <ContactSection />
      <Location />
    </StyledMain>
  );
}

const StyledMain = styled.main`
  .main {
    &__free-space {
      padding: 140px 0;
      background-color: var(--white);
    }
  }
`;
